<template>
  <div
    class="header-avatar"
  >
    <popover
      popper-class="avatar-popover"
      ref="popover"
      placement="bottom"
      transition
      :width="304"
      trigger="click"
      :offset="12"
      v-model:visible="visiblePopover"
    >
      <template #reference>
        <div class="popover-container">
          <div class="hello-message">
            <span class="hello">
              {{ $t('User.Hello') }}
            </span>
            <span class="full-name">
              {{ firstName }}
            </span>
          </div>
          <div class="avatar-container">
            <img
              class="avatar-button"
              :class="{'has-frame': avatarFrame}"
              :src="getAvatar"
            >
            <img
              class="frame"
              :src="avatarFrame"
              v-if="avatarFrame"
            >
          </div>
        </div>
      </template>
      <user-popover v-model:visible="visiblePopover" />
    </popover>
  </div>
</template>

<script>
import Popover from '@/components/popover'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { mapState } from 'vuex'
import UserPopover from './user-popover'

export default {
  name: 'AppHeaderUser',

  components: {
    Popover,
    UserPopover
  },

  data () {
    return {
      visiblePopover: false
    }
  },

  methods: {},

  computed: {
    ...mapState('student', { currentStudent: 'currentStudent' }),

    // Lấy avatar của học sinh
    getAvatar () {
      const me = this
      var image = me.currentStudent.Image || getContextData(ContextDataKey.Image)
      if (!image) {
        return require('@/assets/images/svg/avatar/student/default/default.svg')
      } else {
        if (image.length < 10) {
          return require('@/assets/images/svg/avatar/student/' + image + '.svg')
        } else {
          // return getContextData(ContextDataKey.Image)
          return me.$commonFn.buildPreviewFileUrl({
            fileId: image,
            storageType: me.$enumeration.StorageType.StudentAvatar,
            ownerId: getContextData(ContextDataKey.UserID),
            clientFileName: '',
            isPreview: true,
            width: '47'
          })
        }
      }
    },

    // Khung ảnh đại diện
    avatarFrame () {
      const me = this
      const frame = me.currentStudent.ImageFrame || getContextData(ContextDataKey.ImageFrame)
      if (frame) {
        return me.$commonFn.getStudentAvatarFrame(frame)
      } else {
        return null
      }
    },

    // Tên học sinh
    firstName () {
      const fullName = this.currentStudent?.FullName || getContextData(ContextDataKey.FullName)
      // Xử lý tách fullName lấy firstName
      return fullName.split(' ').slice(-1).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-avatar {
  height: 100%;
  width: auto;
  padding-right: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;

  .avatar-popover {
    padding: 12px 0;
  }

  .popover-container {
    display: flex;

    .hello-message {
      margin: auto 16px auto 8px;

      .full-name {
        @include font-bold();
      }
    }
    .avatar-container {
      position: relative;
      .avatar-button {
        height: 47px;
        width: 47px;
        background-size: 100%;
        background-color: $color-neutral-light-1;
        border-radius: $border-radius-circle;
        border: none;
        &.has-frame {
          height: 32px;
          width: 32px;
          position: relative;
          top: 4px;
          left: 0;
        }
      }
      .frame {
        position: absolute;
        top: -12px;
        left: -4px;
        width: 40px;
      }
    }
  }
  :deep(.el-popover) {
    border-radius: $border-radius-base;
  }
}
</style>
